import React, { useEffect, useState } from 'react';
import { AttachedFileDto, AttachedFileType } from 'models/index';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';

export function Breadcrumbs(props: { currentFile: AttachedFileDto; parentFiles: AttachedFileDto[] }) {
    const allFiles = [...props.parentFiles ?? []]
    if (props.currentFile && !allFiles.find(x => x.id == props.currentFile.id)) {
        allFiles.push(props.currentFile);
    }

    return (
        <Breadcrumb>
            {allFiles.map(x => <Breadcrumb.Item key={x.id} linkAs={Link}
                linkProps={{ to: x.type == AttachedFileType.Root ? `/${x.id}` : `/${x.id}` }}
                active={x.id == props.currentFile?.id && x.type != AttachedFileType.Root}
            >
                {x.type == AttachedFileType.Root ? "Hem" : x.fileName}
            </Breadcrumb.Item>)}
        </Breadcrumb>
    );
}
